<div class="search-bar">
  <form (submit)="onSearch()">
    <div class="input-group">
      <input [(ngModel)]="searchText" name="search" type="text" class="form-control"  placeholder="Ricerca per tipologia, titolo o posizione documento">
      <div class="input-group-btn">
        <button class="btn btn-default" type="submit">
          <i class="glyphicon glyphicon-search"></i>
        </button>
      </div>
    </div>
  </form>
</div>
<ul class="documentipratiche" *ngIf="!!documentList && documentList.length > 0">
  <li *ngFor="let doc of documentList | multiKeyFilter:searchText:['posizione', 'titolo', 'descrizione']">
    <div class="documento">
			<div class="row" style="margin-left: 20px!important">
				<p class="tipodoc"
					[ngClass]="getIconByContentType(doc.contentType)">Documento
					di tipo pdf</p>
				<p class="categoria">{{doc.tipoDocumento.descrizione}}</p>
				<p class="codice">{{doc.posizione}}</p>
			</div>
      <div class="secondo_blocco" style=" max-width: 63%;">
        <p class="identificativo" style="margin-top: 6px;">{{ doc.nomeFile }}</p>
        <h4 class="titolo">{{ doc.titolo }}</h4>
      </div>
      <div class="select-doc">
        <!-- <input type="checkbox" name="" id=""> -->
        <p class="col-sm-3 active singlecheckbox pagamenti">
          <label class='fakelabel'></label> 
          <input id="{{doc.id}}" class="alignright form-control" (change)="onSelectDoc($event, doc)" type="checkbox">
          <label class="" for="{{doc.id}}"></label>
        </p>
      </div>
		</div>
  </li>
</ul>
<div class="spacer"></div>
<div class="row">
    <div class="col-sm-3 col-xs-6">
      <button (click)="onReset(false)" type="reset" class="btn btn-secondary btn-block">Annulla</button>
    </div>
    <div class="col-sm-3 col-xs-6 col-sm-offset-6">
      <button (click)="onProceed(true)" type="submit" class="btn btn-primary btn-block">{{selectedDocs.length > 0 ? 'Procedi': 'Salta'}} </button>
    </div>
</div>